export const getImageUrl = (path: string = '') => {
  const filesUrl = 'https://res.listglobally.com/chat/'

  return (path && `${filesUrl}${path}`) || `${filesUrl}no-picture`
}
